<template>
  <div class="dialog-wrap">
    <el-dialog title="编辑内容"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="700px">
      <el-form class="form"
               :model="dataForm"
               :rules="rules"
               ref="dataForm"
               label-width="100px">
        <div class="title">{{dataForm.questionTitle}}</div>
        <el-input type="textarea"
                  maxlength="500"
                  placeholder="请输入内容"
                  v-model="dataForm.answer_content">
        </el-input>
        <div style="marginTop:20px">
          <el-upload :action="imgUploadUrl"
                     accept=".png,.jpg,.jpeg"
                     list-type="picture-card"
                     :on-preview="handlePictureCardPreview"
                     :on-remove="handleRemove"
                     :on-success="handleSuccess"
                     :file-list="fileList">
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
        <!-- <div>点赞量 <input type="text"
                 v-model="dataForm.virtual_like_count"></div>
        <div>发布状态<el-switch v-model="value"
                     active-color="1"
                     inactive-color="0">
          </el-switch></div> -->
        <el-form-item label="点赞量"
                      style="marginTop:10px"
                      prop="virtual_like_count">
          <el-input v-model="dataForm.virtual_like_count"
                    placeholder="请输入数量"></el-input>
        </el-form-item>

        <el-form-item label="发布状态"
                      style="marginTop:10px"
                      prop="status ">
          <el-switch v-model="value"
                     active-color="1"
                     inactive-color="0">
          </el-switch>
        </el-form-item>
        <el-form-item label="精选"
                      style="marginTop:10px"
                      prop="picked_status">
          <el-switch v-model="dataForm.picked_status"
                     :active-value="1"
                     :inactive-value="0">
          </el-switch>
        </el-form-item>

      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <MajorChoose :visible="majorChooseDialog"
                 :majors="majors"
                 @close="majorChooseDialog = false"
                 @submit="saveMajor"></MajorChoose>
    <CollegeChoose :visible="collegeChooseDialog"
                   :colleges="colleges"
                   @close="collegeChooseDialog = false"
                   @submit="saveCollege"></CollegeChoose>
  </div>
</template>

<script>
import { teacherCreate } from '@/api/common'
import {
  seniorList,
  userAnswerCreated,
  questionDetail,
  questionPut,
} from '@/api/senior'
import { imgUploadUrl, uploadHeaders } from '@/config/index'
import MajorChoose from '@/components/dialog/major/MajorChoose'
import CollegeChoose from '@/components/dialog/college/CollegeChoose'
export default {
  components: { MajorChoose, CollegeChoose },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    typeList: {
      type: Array,
      default: () => {
        return []
      },
    },
    row: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      colleges: [],
      activeSwitch: 0,
      fileList: [],
      majors: [],
      authors: [],
      majorChooseDialog: false,
      collegeChooseDialog: false,
      value: false,
      dialogVisible: this.visible,
      dataForm: {
        id: '',
        question_id: '',
        questionTitle: '',
        answer_content: '',
        virtual_like_count: 0,
        picked_status: false,
      },
      dialogImageUrl: '',
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      rules: {},
      switch: 0,
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    row(val) {
      console.log('valfff', val)
      this.dataForm.id = val.id
      if (val.answer_img_urls != '') {
        this.fileList = val.answer_img_urls.split(',').map((item, index) => ({
          url: item,
          name: 'image' + index,
        }))
      }
      // this.dataForm.picked_status =val.picked_status
      this.dataForm.answer_content = val.answer_content
      this.dataForm.virtual_like_count = val.virtual_like_count
      this.dataForm.answer_img_urls =
        val.answer_img_urls != '' ? val.answer_img_urls : ''
      if (val.status == 0) {
        this.value = false
      } else {
        this.value = true
      }
      if (val.picked_status == 0) {
        this.$set(this.dataForm, 'picked_status', 0)
      } else {
        this.$set(this.dataForm, 'picked_status', 1)
      }
      console.log(' this.dataForm.picked_status', this.dataForm.picked_status)
      this.questionDetails({ id: val.question_id })
    },
  },
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove(file, fileList) {
      this.fileList = fileList.map((item) => {
        if (item.response) {
          return item.response.data
        } else {
          return item
        }
      })
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList.map((item) => {
        if (item.response) {
          return item.response.data
        } else {
          return item
        }
      })
    },
    questionDetails(data) {
      questionDetail(data).then((res) => {
        this.dataForm.questionTitle = res.question_title
      })
    },

    fetchAuthorList(name) {
      seniorList({ keyword: name, isPaging: 0 }).then((res) => {
        this.authors = res.list
      })
    },
    handleMajorChoose() {
      this.majorChooseDialog = true
    },
    handleCollegeChoose() {
      this.collegeChooseDialog = true
    },
    saveMajor({ majors }) {
      this.majors = majors
    },
    saveCollege({ colleges }) {
      this.colleges = colleges
    },
    handleCollegeRemove(item) {
      this.colleges = this.colleges.filter((v) => v.id !== item.id)
    },
    handleMajorRemove(item) {
      this.majors = this.majors.filter((v) => v.id !== item.id)
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let picture_url = this.fileList.map((item) => item.url).join(',')
          const params = {
            answer_content: this.dataForm.answer_content,
            answer_img_urls: picture_url,
            virtual_like_count: this.dataForm.virtual_like_count,
            status: this.value ? 1 : 0,
            id: this.dataForm.id,
            picked_status: this.dataForm.picked_status,
          }
          // const params = Object.assign({}, this.dataForm, {
          //   status: this.value ? 1 : 0,
          // })
          console.log('333', params)
          questionPut(params)
            .then((res) => {
              this.$message.success(`修改成功`)
              this.$refs['dataForm'].resetFields()

              this.$emit('submit')
              this.handleClose()
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
      this.fileList = []
    },

    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.answer_img_urls = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleUploadQrcodeSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.answer_img_urls = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
  },
}
</script>
<style>
</style>
<style lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ebeef5 !important;
}
::v-deep .el-input__inner {
  width: 80px !important;
}
::v-deep .el-form-item__label {
  width: 70px !important;
}
::v-deep .el-form-item__content {
  margin-left: 70px !important;
}
.dialog-wrap {
  .title {
    font-weight: 500;
    font-size: 18px;
    color: #303133;
    margin-bottom: 20px;
  }
  .form {
    margin-bottom: -18px;

    .avatar-uploader /deep/ .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader /deep/ .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 128px;
      height: 128px;
      line-height: 128px;
      text-align: center;
    }
    .avatar {
      display: block;
      width: 128px;
      height: 128px;
      object-fit: cover;
    }
  }
}
</style>
